import { axios } from '@v2/utils/httpRequest.js';

const ADMIN_API_ROOT = '/api/v2/admin/pickup_ads';
const CLINIC_PICKUP_API_ROOT = '/api/v2/clinic/pickup_ads';
const CLINIC_DELIVERED_PICKUP_API_ROOT = '/api/v2/clinic/delivered_pickup_ads';

// actions
export default {
  /** [admin側] ピックアップ広告一覧を取得 */
  async fetchAdminPickupAds({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${ADMIN_API_ROOT}`)
        .then((response) => {
          console.log('response', response);
          commit('updateAdminPickupAds', response.data.pickup_ads);
          resolve();
        })
        .catch((error) => {
          console.log(`error: ${error}`);
          console.log('通信エラーが発生しました');
          reject();
        });
    });
  },

  /** [admin側] ピックアップ広告のソート順を更新 */
  async updateAdminPickupAd({ commit }, ids) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${ADMIN_API_ROOT}/update_sort`, { sort_order_ids: ids })
        .then((response) => {
          console.log('response', response);
          commit('updateAdminPickupAds', response.data.pickup_ads);
          resolve();
        })
        .catch((error) => {
          console.log(`error: ${error}`);
          console.log('通信エラーが発生しました');
          reject();
        });
    });
  },

  /** [admin側] ピックアップ広告を削除 */
  async deleteAdminPickupAd(_, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${ADMIN_API_ROOT}/${id}`)
        .then((response) => {
          console.log('response', response);
          resolve();
        })
        .catch((error) => {
          console.log(`error: ${error}`);
          console.log('通信エラーが発生しました');
          reject();
        });
    });
  },

  /** [病院側] ピックアップ広告一覧を取得 */
  async fetchClinicPickupAds({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${CLINIC_PICKUP_API_ROOT}`)
        .then((response) => {
          console.log('response', response);
          commit('updateClinicPickupAds', response.data.pickup_ads);
          resolve();
        })
        .catch((error) => {
          console.log(`error: ${error}`);
          console.log('通信エラーが発生しました');
          reject();
        });
    });
  },

  /** [病院側] ピックアップ広告の既読状態を更新 */
  async updateDeliveredPickupAd(_, id) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${CLINIC_DELIVERED_PICKUP_API_ROOT}/${id}`)
        .then((response) => {
          console.log('response', response);
          resolve();
        })
        .catch((error) => {
          console.log(`error: ${error}`);
          console.log('通信エラーが発生しました');
          reject();
        });
    });
  },
};
